
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { ReissueCardUpgrade } from "./ReissueCardUpgrade";
import { ReissueCardUpgradeStore } from "./ReissueCardUpgradeStore";
import { ReissueCardUpgradeRoutes } from "./ReissueCardUpgradeRoutes";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class ReissueCardUpgradeContainer extends React.Component<IProps, {}> {
    store: ReissueCardUpgradeStore;

    constructor(props: any) {
        super(props);
        this.store = new ReissueCardUpgradeStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized && this.props.externalInterfaceStore.currentCardId) {
                await this.store.load(this.props.externalInterfaceStore.currentCardId);
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("reissueCardUpgrade.document.title");

        return (
            <div>
                <Route exact path={ReissueCardUpgradeRoutes.ROOT} render={this.withStore(ReissueCardUpgrade)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reissueCardUpgrade/ReissueCardUpgradeContainer.tsx